<template>
  <LazyHydrate v-if="type !== 'Criteo' && type !== 'FooterAd' && lazy" :when-visible="{ rootMargin: '1200px' }">
    <template v-if="type === 'Adblock'">
      <component :is="type" v-bind="$attrs" :class-name="className"></component>
    </template>
    <template v-else>
      <component :is="type" v-bind="$attrs" :class="className"></component>
    </template>
  </LazyHydrate>
  <component :is="type" v-else v-bind="$attrs" :class="className"></component>
</template>
<script>
import { defineComponent } from '@nuxtjs/composition-api';
import LazyHydrate from 'vue-lazy-hydration';
import Criteo from './Criteo';
import FooterAd from './FooterAd';
import Outstream from './Outstream';

export default defineComponent({
  props: {
    type: {
      type: String,
      required: true,
    },
    className: {
      type: String,
    },
    lazy: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    GPT: () => import(/* webpackChunkName: "gpt" */ './GPT'),
    Yandex: () => import(/* webpackChunkName: "gpt" */ './Yandex'),
    Adblock: () => import(/* webpackChunkName: "adblock" */ './Adblock'),
    Criteo,
    Taboola: () => import(/* webpackChunkName: "taboola" */ './Taboola'),
    SponsoredArticle: () => import(/* webpackChunkName: "sponsoredArticle" */ './SponsoredArticle'),
    HtmlAd: () => import(/* webpackChunkName: "htmlAd" */ '@/modules/common/components/RenderHtml'),
    IdealMedia: () => import(/* webpackChunkName: "idealMedia" */ './IdealMedia'),
    FooterAd,
    Outstream,
    LazyHydrate,
  },
});
</script>
